<ng-template #headTemplate>
  <ng-content select="mg-clipped-html-head"></ng-content>
</ng-template>

<ng-template #tailTemplate>
  <ng-content select="mg-clipped-html-tail"></ng-content>
</ng-template>

<div #viewContainer></div>
